import $http from '@Config/axios';
import $store from '@Store';

const prefix = 'prescricao-aplicacao';
const tipo = 'Aplicação de prescrição';
const artigo = 'a';

export default {
  indexAplicacoesVisita(params) {
    return new Promise((resolve, reject) => {
      $http.post(`${prefix}/aplicacoes-visita`, params)
        .then(response => resolve(response))
        .catch(response => reject(response));
    });
  },
  store(params) {
    return new Promise((resolve, reject) => {
      $http.post(prefix, params)
        .then(response => {
          $store.dispatch('SHOW_SNACKBAR', { message: `${tipo} salv${artigo} com sucesso!` });
          resolve(response);
        })
        .catch(response => reject(response));
    });
  },
  excluirAplicacao(params) {
    return new Promise((resolve, reject) => {
      $http.post(`${prefix}/excluir-aplicacao`, params)
        .then(response => {
          $store.dispatch('SHOW_SNACKBAR', { message: `${tipo} excluíd${artigo} com sucesso!` });
          resolve(response);
        })
        .catch(response => reject(response));
    });
  }
};
